import type { HttpAdapter } from "../core/adapters/axios.adapter";
import type { Payment, Profile } from "./profile.models";

export class ProfileService {
    constructor(private profileAdapter: HttpAdapter) { }

    async getPayments(): Promise<Payment[] | null> {
        const response = await this.profileAdapter.get<Profile>('/payments');
        if (response.status !== 200 || !response.data.payments) {
            return null;
        }
        return response.data.payments;
    }

    async updateEmail(email: string): Promise<void> {
        await this.profileAdapter.patch('/email', { email });
    }

    async deleteAccount(): Promise<void> {
        await this.profileAdapter.delete('');
    }
}
